import { Tooltip as ChakraTooltip, Popover, Portal, useMediaQuery } from '@chakra-ui/react'
import * as React from 'react'

export interface TooltipProps extends ChakraTooltip.RootProps {
  showArrow?: boolean
  portalled?: boolean
  portalRef?: React.RefObject<HTMLElement | null>
  content: React.ReactNode
  desktopContentProps?: ChakraTooltip.ContentProps
  mobileContentProps?: React.ComponentProps<typeof Popover.Content>
  disabled?: boolean
  mobileMaxW?: React.ComponentProps<typeof Popover.Content>['maxW']
}

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(
  function Tooltip(props, ref) {
    const {
      showArrow,
      children,
      disabled,
      portalled = true,
      content,
      desktopContentProps,
      mobileContentProps,
      portalRef,
      mobileMaxW = { base: '90vw', sm: '280px' },
      ...rest
    } = props

    const [canHover] = useMediaQuery(['(hover: hover) and (pointer: fine)'])

    if (disabled) return children as any

    // MOBILE / TOUCH: Popover on click/tap
    if (!canHover) {
      return (
        <Popover.Root positioning={{ placement: 'bottom-start' }}>
          <Popover.Trigger asChild>{children}</Popover.Trigger>

          <Portal disabled={!portalled} container={portalRef}>
            <Popover.Positioner>
              <Popover.Content
                position="relative"
                bg="bg.inverted"
                color="fg.inverted"
                maxW={mobileMaxW}
                {...mobileContentProps}
                ref={ref}
              >
                {showArrow && (
                  <Popover.Arrow>
                    <Popover.ArrowTip style={{ background: 'var(--chakra-colors-bg-inverted)' }} />
                  </Popover.Arrow>
                )}
                <Popover.Body>{content}</Popover.Body>
              </Popover.Content>
            </Popover.Positioner>
          </Portal>
        </Popover.Root>
      )
    }

    // DESKTOP: Tooltip по hover
    return (
      <ChakraTooltip.Root {...rest}>
        <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
        <Portal disabled={!portalled} container={portalRef}>
          <ChakraTooltip.Positioner>
            <ChakraTooltip.Content
              ref={ref}
              bg="bg.inverted"
              color="fg.inverted"
              {...desktopContentProps}
            >
              {showArrow && (
                <ChakraTooltip.Arrow>
                  <ChakraTooltip.ArrowTip />
                </ChakraTooltip.Arrow>
              )}
              {content}
            </ChakraTooltip.Content>
          </ChakraTooltip.Positioner>
        </Portal>
      </ChakraTooltip.Root>
    )
  }
)
